var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatellite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6061 7.05024L16.9493 1.39339L15.5351 2.8076L21.1919 8.46445L22.6061 7.05024ZM20.4848 9.17156L14.828 3.51471L13.4138 4.92892L19.0706 10.5858L20.4848 9.17156ZM14.828 7.75735L16.2422 9.17156L14.828 10.5858L16.2422 12C17.0232 12.781 17.0232 14.0474 16.2422 14.8284L14.828 16.2426C14.0469 17.0237 12.7806 17.0237 11.9995 16.2426L10.5853 14.8284L9.17112 16.2426L7.75691 14.8284L9.17112 13.4142L7.75691 12C6.97586 11.2189 6.97586 9.95261 7.75691 9.17156L9.17112 7.75735C9.95217 6.9763 11.2185 6.9763 11.9995 7.75735L13.4138 9.17156L14.828 7.75735ZM21.899 16.2426C20.3369 14.6805 17.8043 14.6805 16.2422 16.2426C14.6801 17.8047 14.6801 20.3374 16.2422 21.8995L21.899 16.2426ZM2.80716 15.5355L8.46401 21.1924L7.0498 22.6066L1.39295 16.9497L2.80716 15.5355ZM4.92848 13.4142L10.5853 19.0711L9.17112 20.4853L3.51427 14.8284L4.92848 13.4142Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.7aea60c2a5c5e0928d96211226626d7a.svg";
export { ForwardRef as ReactComponent };